import type { MaterialitySurveyModelMinData } from '@apps/materiality-tracker/api/materiality-assessment';
import { useUnlockAssessment } from '@apps/materiality-tracker/hooks/useUnlockAssessment';
import { isAssessmentPaid } from '@apps/materiality-tracker/utils';
import { BannerAlert } from '@g17eco/molecules/alert';
import { VariantType } from '@g17eco/molecules/alert/BannerAlert';
import { Button } from 'reactstrap';

export const UnlockAssessmentAlert = ({ survey }: { survey: MaterialitySurveyModelMinData }) => {
  const { handleUnlock, isUnlocking } = useUnlockAssessment();

  if (isAssessmentPaid(survey)) {
    return null;
  }

  return (
    <BannerAlert variant={VariantType.Sticky}>
      <div className='d-flex align-items-center gap-3 text-ThemeTextWhite'>
        <i className='fal fa-lock text-lg' />
        <div>
          <Button
            className='p-0 text-ThemeTextWhite fw-semibold'
            color='link'
            onClick={() => handleUnlock(survey)}
            disabled={isUnlocking}
          >
            Unlock
          </Button>{' '}
          your full results, personalised insights & materiality report now
        </div>
        <Button color='secondary' disabled={isUnlocking} onClick={() => handleUnlock(survey)}>
          Unlock now
        </Button>
      </div>
    </BannerAlert>
  );
};
